var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCertificateBadge = function SvgCertificateBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F0AC0B",
    d: "M13.995.948a2.595 2.595 0 0 1 4.01 0l1.506 1.819a2.599 2.599 0 0 0 2.46.907l2.308-.413c1.604-.287 3.074.962 3.073 2.61l-.001 2.374c0 .948.498 1.824 1.31 2.298l2.03 1.186c1.41.823 1.743 2.737.696 4l-1.508 1.818a2.677 2.677 0 0 0-.454 2.612l.802 2.23c.558 1.55-.402 3.232-2.005 3.518l-2.308.41a2.626 2.626 0 0 0-2.006 1.706l-.8 2.23c-.557 1.55-2.36 2.215-3.77 1.39l-2.029-1.188a2.588 2.588 0 0 0-2.619 0l-2.028 1.188c-1.41.825-3.213.16-3.77-1.39l-.8-2.23a2.626 2.626 0 0 0-2.006-1.705l-2.308-.411c-1.603-.286-2.563-1.969-2.005-3.518l.802-2.23c.32-.89.147-1.887-.454-2.612L.613 15.729c-1.047-1.263-.713-3.177.697-4l2.03-1.186a2.657 2.657 0 0 0 1.31-2.298l-.002-2.373c0-1.649 1.47-2.898 3.073-2.611l2.307.413c.922.165 1.86-.18 2.461-.907l1.506-1.82Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16 20c3.728 0 6.75-2.91 6.75-6.5S19.728 7 16 7s-6.75 2.91-6.75 6.5S12.272 20 16 20Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m11.52 18.52-.01 7.38c0 .9.63 1.34 1.41.97l2.68-1.27c.22-.11.59-.11.81 0l2.69 1.27c.77.36 1.41-.07 1.41-.97v-7.56",
    opacity: 0.4
  })));
};
export default SvgCertificateBadge;